import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import { closeModal } from 'Store/actions';
import RenderActiveModals from './Modals/RenderActiveModals';
import axios from 'axios';
import { catchTJKError } from 'Utils/catchTJKError';
import ProjectConfig from 'ProjectConfig';
import Contract from 'Components/Modal/Contract';
import Modal from 'Components/Modal';
import History from 'Store/history';
import LottieLoader from 'Components/LottieLoader';

const ScratchCardList = loadable(() => pMinDelay(import('./ScratchCardList'), 300), {
  fallback: <Loading/>
});

const CardsDesign = loadable(() => pMinDelay(import('./ScratchOffDesign'), 300), {
  fallback: <Loading/>
});

const ScratchCardSuccess = loadable(() => pMinDelay(import('./ScratchCardSuccess'), 300), {
  fallback: <Loading/>
});


const AsyncScratchCardLayout = props => {
  const API_GATEWAY = ProjectConfig.API_GATEWAY;
  const { page } = props;
  const [loading, setLoading] = useState(false);
  const [contractContent, setContractContent] = useState(null);
  const [otherGames, setOtherGames] = useState([]);
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    navigationType: 'horse-racing',
    helmet: {
      bodyAttributes: {
        class: `${props.userAgent.device?.type} ${page !== 'bilet-detay' ? 'bg-white' : 'bg-grey'} hide-betslip hide-sticky-navigation`
      }
    }
  };


  const dispatch = useDispatch();
  let pageContent = null;
  const modalData = useSelector(state => state.modalData);
  const {
    isAuthenticated,
  } = useSelector(state => state.auth);

  switch (page) {
    case 'oyna-kazan':
      pageContent = <ScratchCardList { ...props } games={ otherGames } />;
      break;
    case 'kart':
      pageContent = <CardsDesign { ...props } />;
      break;
    case 'tebrikler':
      pageContent = <ScratchCardSuccess { ...props } />;
      break;
    default:
      break;
  }

  const isModalOpen = modalNameRequest => {
    const { modalNames } = modalData;
    return modalNames.some(modalName => modalName === modalNameRequest);
  };

  function closeModalFunc (modalName) {
    dispatch(closeModal(modalName));
  }

  const getContract = contractType => {
    axios.get(`${API_GATEWAY}/contract/content/${contractType}`).then(response => {
      catchTJKError(response?.data);
      setContractContent(response?.data?.body);
    });
  };

  const checkContract = async slug => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_GATEWAY}/igames/dg/get/${slug}`);
      catchTJKError(res?.data);
      const { contractType, showContract, games } = res?.data?.body;
      if (showContract) {
        getContract(contractType);
      }
      if (games) {
        setOtherGames(games);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.location.pathname.includes('oyna-kazan') && isAuthenticated) {
      checkContract('oyna-kazan');
    }
  }, [props?.location?.pathname, isAuthenticated]);

  return (
    <ApplicationLayout { ...pageConfig } { ...props } >
      { loading && (
        <div className="tjk-loader">
          <LottieLoader type="loading" loop={ true } autoplay width="75px"/>
        </div>
      ) }
      { pageContent }
      <RenderActiveModals
        modalData={ modalData }
        isModalOpen={ isModalOpen }
        closeModal={ name => {
          closeModalFunc(name);
        } }
      />
      <Modal
        isOpen={ contractContent }
        title={ contractContent?.title }
        closeIconVisible={ false }
        maxHeight='calc(100vh - 112px)'
        onOverlayClick={ () => History.push('/sans-oyunlari') }
        buttonArea={ {
          primaryButton: contractContent?.contractType === 'DIGITAL_GAMES_CALL_CENTER' ? null : {
            onClick: () => {
              axios.post('/contractAcception/save', { contractTypeDatasrvEnum: contractContent?.contractType }).then(response => {
                if (response?.data?.success) {
                  setContractContent(null);
                  checkContract('oyna-kazan');
                }
              });
            },
            label: 'ONAYLA',
          },
          secondaryButton: {
            variant: 'secondary',
            onClick: () => {
              History.push('/sans-oyunlari');
            },
            label: contractContent?.contractType === 'DIGITAL_GAMES_CALL_CENTER' ? 'TAMAM' : 'VAZGEÇ',
          }
        } }
        onClose={ () => History.push('/sans-oyunlari') }>
        <Contract>{ contractContent?.content }</Contract>
      </Modal>
    </ApplicationLayout>
  );
};

AsyncScratchCardLayout.propTypes = {
  userAgent: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  location: PropTypes.object,
  page: PropTypes.string,
};

export default AsyncScratchCardLayout;
